import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function ProblemSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <div ref={ref} className="grain-section relative w-full bg-page-bg px-6 py-20 md:py-28" data-id="element-312" data-mp="30hzit4mp20my">
      {/* Chapter indicator */}
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={inView ? {
      opacity: 1,
      x: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto mb-14 md:mb-16" data-id="element-313" data-mp="2vp69s4k70652">
        <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-314" data-mp="35in4rbw2frab">
          <div className="text-8xl md:text-9xl font-black text-black/5 font-sans tracking-tighter" data-id="element-315" data-mp="3jfaekf94abxn">
            01
          </div>
          <div className="h-px w-24 bg-black/10 hidden md:block" data-id="element-316" data-mp="1p20zm7xsxy80"></div>
          <div data-id="element-317" data-mp="1p454as3iz19c">
            <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-318" data-mp="1p3vmvswjq2f9">
              Chapter One
            </p>
            <h2 className="text-4xl md:text-6xl font-bold text-teal-600 tracking-tight" data-id="element-319" data-mp="jdwlr0kttsxy">
              Why You're In This Position In the First Place...
            </h2>
          </div>
        </div>
      </motion.div>

      <div className="max-w-4xl mx-auto space-y-14 md:space-y-16" data-id="element-320" data-mp="sd04u4jzu8cg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="space-y-8 text-xl md:text-2xl text-ink-light leading-relaxed font-light" data-id="element-321" data-mp="x51poev897e3">
          <p className="font-medium text-ink" data-id="element-322" data-mp="1c2279pjpflyu">
            See if this sounds true for you?
          </p>
          <p data-id="element-323" data-mp="1g3w57q2imbvb">You've been doing everything you're supposed to.</p>
          <p data-id="element-324" data-mp="1g19w3lzz7oaz">
            You've seen the specialists. Tried the diets. Taken the supplements.
            Read the articles, listened to the podcasts, followed the protocols.
          </p>
          <p data-id="element-325" data-mp="3hv0uifgz70ch">
            You're constantly researching... Constantly trying new things...
          </p>

          <div className="bg-white p-10 rounded-3xl shadow-sm border-l-4 border-teal-500 my-10" data-id="element-326" data-mp="p2d406oxw3dr">
            <p className="text-2xl font-medium text-ink" data-id="element-327" data-mp="k3a9hg6l5fk1">
              But despite all that effort? You're still stuck in the same damn
              place. Chasing symptoms that just keep bouncing around like a game
              of whack-a-mole.
            </p>
          </div>

          <p data-id="element-328" data-mp="17xk0jcoes3ui">
            And here's what makes it even MORE frustrating... You KNOW
            something's not right. You can feel it. But you don't know what the
            "right things" even ARE. Because nobody's been able to tell you.
          </p>

          <p data-id="element-329" data-mp="1cpbgyuduot6x">
            Here's why:{' '}
            <span className="font-bold text-ink" data-id="element-330" data-mp="1cqd0zocugq0s">
              Most practitioners don't actually know how to FIX things.
            </span>{' '}
            They know how to MANAGE symptoms. They know how to prescribe meds
            that cover up problems.
          </p>

          <p data-id="element-331" data-mp="25dctayryuruz">
            But when it comes to actually DIAGNOSING the root cause... And
            creating a PRECISE plan to fix it at the cellular level... They're
            lost. Because they were never trained to think that way.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.8
      }} className="space-y-8 border-t border-black/5 pt-10 md:space-y-10 md:pt-12" data-id="element-332" data-mp="20cykheijjdvw">
          <h3 className="text-3xl md:text-5xl font-bold text-ink tracking-tight leading-tight" data-id="element-333" data-mp="1cnnr4i3islrs">
            The Real Problem Isn't Lack of Effort... <br data-id="element-334" data-mp="1hlyy8l2fki6b" />
            <span className="text-teal-600" data-id="element-335" data-mp="1hniewcs00v8m">
              It's A Lack of Precisely Understanding Human Biology OUTSIDE the
              Mainstream System!
            </span>
          </h3>

          <div className="space-y-8 text-xl text-ink-light leading-relaxed font-light" data-id="element-336" data-mp="18kr32bv7nxgg">
            <p data-id="element-337" data-mp="10kbbzyr8hsuh">
              You know what kills me? When I see someone who's been busting
              their ass for YEARS... Trying protocol after protocol... Only to
              discover that 90% of what they've been doing... Was either
              pointless or making things worse.
            </p>
            <p data-id="element-338" data-mp="mswpvj215bj7">
              Not because they're stupid. But because nobody took the time to
              actually UNDERSTAND their unique biology.
            </p>

            <div className="bg-gradient-to-br from-[#1a1a2e] to-[#0f172a] text-white p-12 rounded-[2.5rem] shadow-xl my-10" data-id="element-339" data-mp="cw1u37x55p8m">
              <p className="text-2xl md:text-3xl font-medium leading-relaxed" data-id="element-340" data-mp="7xqjuw2xpcpv">
                Your body isn't a collection of separate problems to be fixed.
                Your joint pain isn't separate from your brain fog. Everything
                is connected.
              </p>
            </div>

            <p data-id="element-341" data-mp="1ya67s15ifvie">
              And when you treat symptoms in isolation... You're basically
              playing medical whack-a-mole. One thing gets "better"... Another
              thing pops up. It's exhausting. And it's completely unnecessary.
            </p>

            <p data-id="element-342" data-mp="3pwt96fwfer84">
              Because when you work with someone who understands how your ENTIRE
              system operates... When they can see the underlying patterns
              everyone else has missed... Everything becomes clear. Suddenly
              you're not managing 12 different problems. You're solving ONE core
              issue.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={inView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.7,
        duration: 0.8
      }} data-id="element-343" data-mp="368tyt65rxm38">
          <p className="text-center text-xl font-medium text-ink mt-8" data-id="element-344" data-mp="lj4lixkpy8cn">
            That's what precision looks like. And it's what you're about to
            experience.
          </p>
        </motion.div>
      </div>
    </div>;
}